import React from "react";
import { isPortalTestEnvironment } from "../utils/environmentMode";
import {
  hasValidTestSiteAccessCookie,
  isValidTestSiteAccessInput,
  setTestSiteAccessCookie,
  TEST_SITE_REQUIRED_CONFIRMATION,
} from "../utils/testSiteAccess";

const TestSiteAccessGate = () => {
  const [isConfirmed, setIsConfirmed] = React.useState(() => hasValidTestSiteAccessCookie());
  const [confirmation, setConfirmation] = React.useState("");
  const [pin, setPin] = React.useState("");
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    if (!isPortalTestEnvironment() || !isConfirmed) return undefined;
    const intervalId = window.setInterval(() => {
      if (!hasValidTestSiteAccessCookie()) {
        setIsConfirmed(false);
      }
    }, 60 * 1000);
    return () => window.clearInterval(intervalId);
  }, [isConfirmed]);

  if (!isPortalTestEnvironment() || isConfirmed) return null;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!isValidTestSiteAccessInput({ confirmation, pin })) {
      setError("Enter the required sentence and PIN to continue.");
      return;
    }
    setTestSiteAccessCookie();
    setIsConfirmed(true);
  };

  return (
    <div
      className="fixed inset-0 z-[13000] flex items-center justify-center bg-slate-950/75 px-4 py-6"
      role="presentation"
    >
      <div
        className="w-full max-w-lg overflow-hidden rounded-2xl border border-red-200 bg-white text-left shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="test-site-access-title"
        aria-describedby="test-site-access-description"
      >
        <form onSubmit={handleSubmit}>
        <div className="border-b border-red-100 bg-red-50 px-5 py-4">
          <p className="text-[11px] font-black uppercase tracking-[0.22em] text-red-700">Test site access</p>
          <h2 id="test-site-access-title" className="mt-1 text-xl font-extrabold text-slate-950">
            Confirm before using this site
          </h2>
          <p id="test-site-access-description" className="mt-2 text-sm font-medium leading-6 text-slate-700">
            This environment is for developer-team testing only. Payments and operational actions are not valid here.
          </p>
        </div>

        <div className="space-y-4 px-5 py-5">
          <label className="block">
            <span className="text-sm font-bold text-slate-800">Type this sentence</span>
            <span className="mt-1 block rounded-lg bg-slate-100 px-3 py-2 font-mono text-xs text-slate-800">
              {TEST_SITE_REQUIRED_CONFIRMATION}
            </span>
            <textarea
              className="mt-2 min-h-[88px] w-full resize-none rounded-xl border border-slate-300 px-3 py-2 text-sm text-slate-950 outline-none transition focus:border-red-500 focus:ring-2 focus:ring-red-100"
              value={confirmation}
              onChange={(event) => {
                setConfirmation(event.target.value);
                setError("");
              }}
              autoFocus
              required
            />
          </label>

          <label className="block">
            <span className="text-sm font-bold text-slate-800">PIN</span>
            <input
              className="mt-2 w-full rounded-xl border border-slate-300 px-3 py-2 text-sm text-slate-950 outline-none transition focus:border-red-500 focus:ring-2 focus:ring-red-100"
              type="password"
              inputMode="numeric"
              autoComplete="off"
              value={pin}
              onChange={(event) => {
                setPin(event.target.value);
                setError("");
              }}
              required
            />
          </label>

          {error ? <p className="rounded-lg bg-red-50 px-3 py-2 text-sm font-semibold text-red-700">{error}</p> : null}
        </div>

        <div className="flex items-center justify-end border-t border-slate-200 bg-slate-50 px-5 py-4">
          <button
            type="submit"
            className="inline-flex items-center justify-center rounded-full bg-red-700 px-5 py-2.5 text-sm font-bold text-white transition hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-red-200"
          >
            I understand
          </button>
        </div>
        </form>
      </div>
    </div>
  );
};

export default TestSiteAccessGate;
